<template>
  <custom-dialog width="1000px" :title="model.title" :visible="visible" v-on="$listeners" :append-to-body="true">
    <div class="dialog-body">
      <el-form :inline="true">
        <el-form-item v-if="model.type == 'edit'">
          <el-button @click="onSyncSetting()" type="primary">{{ $t('dms_productCode_lifespan_dialog.tbxysm') }}</el-button>
        </el-form-item>
        <el-form-item v-if="model.type == 'edit'">
          <el-button @click="onClearSetting" type="primary">{{ $t('dms_productCode_lifespan_dialog.qing_chu_she_zhi') }}</el-button>
        </el-form-item>
        <el-form-item style="float: right">
          <search-input v-model="formSearch.component" :placeholder="$t('dms_productCode_lifespan_dialog.bjmcbh')" @fetch="getLifespanList"></search-input>
        </el-form-item>
        <el-form-item style="float: right; margin-right: 13px">
          <custom-select
            url="productCodeParentList"
            :params="{ productCode: model.data.productCode }"
            v-model="formSearch.parentCode"
            :props="{ label: 'componentName', value: 'componentCode' }"
            :placeholder="$t('dms_productCode_lifespan_dialog.xzbjfz')"
            width="100%"
            @change="getLifespanList"
          ></custom-select>
        </el-form-item>
      </el-form>
      <custom-table :data="tableList" tableCode="product_code_lifespan" :index="true" :slots="['maxVal', 'criticalVal']">
        <template slot="maxVal" slot-scope="scope">
          <div class="ub" v-if="model.type == 'edit'">
            <el-input type="number" v-model="scope.row.maxVal" style="width: 100px; margin-right: 10px"></el-input>
            <div>{{ scope.row.referenceMaxVal || '-' }}</div>
          </div>
          <span v-else>{{ scope.row.maxVal || '-' }} / {{ scope.row.referenceMaxVal || '-' }}</span>
        </template>
        <template slot="criticalVal" slot-scope="scope">
          <div class="ub" v-if="model.type == 'edit'">
            <el-input type="number" v-model="scope.row.criticalVal" style="width: 100px; margin-right: 10px"></el-input>
            <div>{{ scope.row.referenceCriticalVal || '-' }}</div>
          </div>
          <span v-else>{{ scope.row.criticalVal || '-' }} / {{ scope.row.referenceCriticalVal || '-' }}</span>
        </template>
      </custom-table>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button v-if="model.type == 'edit'" size="small" @click="visible = false">{{ $t('Common.com_cancel') }}</el-button>
      <el-button v-if="model.type == 'edit'" size="small" type="primary" @click="onConfirm()">{{ $t('Common.com_confirm') }}</el-button>
      <el-button v-else size="small" type="primary" @click="visible = false">{{ $t('Common.com_confirm') }}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins';

export default {
  mixins: [dialogMixins],
  data() {
    return {
      formSearch: {
        parentCode: '',
        component: '',
        productCode: '',
      },
      tableList: [],
    };
  },

  mounted() {
    this.initDialog();
  },
  methods: {
    initDialog() {
      this.formSearch.productCode = this.model.data.productCode;
      this.getLifespanList();
    },
    getLifespanList: function () {
      this.$getJSON(apis.productCodeLifeList, this.formSearch).then((res) => {
        this.tableList = res.data;
      });
    },
    // 同步设置
    onSyncSetting: function () {
      this.tableList.forEach((item) => {
        this.$set(item, 'maxVal', item.referenceMaxVal);
        this.$set(item, 'criticalVal', item.referenceCriticalVal);
      });
    },
    // 清除设置
    onClearSetting: function () {
      this.tableList.forEach((item) => {
        this.$set(item, 'maxVal', '');
        this.$set(item, 'criticalVal', '');
      });
    },
    // 保存提交
    onConfirm: function () {
      const list = this.tableList.map((t) => ({
        componentCode: t.componentCode,
        productCode: t.productCode,
        criticalVal: t.maxVal ? Number(t.criticalVal) : null,
        maxVal: t.criticalVal ? Number(t.maxVal) : null,
      }));
      this.$postJSON(apis.productCodeLifeSetup, list).then(() => {
        this.$message({
          message: this.$t('Common.com_handle_success'),
          type: 'success',
        });
        this.visible = false;
      });
    },
  },
};
</script>

<style lang="scss"></style>
